/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';

import { setOutputs, setInputs } from '@redux/actions/FinancialModelActions';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
// import Button from '@material-ui/core/Button';

import clsx from 'clsx';

import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from '@material-ui/core/IconButton';

import { CircularProgress } from '@material-ui/core';
import InputControlled from './InputControlled';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 12,
    borderBottom: 'none !important',
    width: 75
  }
}))(TableCell);

const StyledTableCellStrong = withStyles((theme) => ({
  head: {
    fontWeight: 'bold'
  },
  body: {
    fontSize: 12,
    fontWeight: 'bold',
    borderBottom: 'none !important'
  }
}))(TableCell);

const TableCellTitleStrong = withStyles((theme) => ({
  body: {
    fontSize: 14,
    fontWeight: 'bold',
    borderBottom: 'none !important'
  }
}))(TableCell);

const TableCellTitle = withStyles((theme) => ({
  body: {
    fontSize: 14,
    borderBottom: 'none !important',
    '& span': {
      color: '#ff9800'
    }
  }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: 'rgba(14,78,173,0.05)'
  }
}))(TableRow);

const StrongTableRow = withStyles((theme) => ({
  root: {
    borderBottom: '3px solid #FFCD00'
  }
}))(TableRow);

const NetTableRow = withStyles((theme) => ({
  root: {
    backgroundColor: 'rgba(14,78,173,0.2)'
  }
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 700
  },
  tableContainer: {
    borderTop: '5px solid #FFCD00',
    margin: '30px auto !important'
  },
  header: {
    padding: '20px',
    display: 'flex',
    alignItems: 'center',

    '& p': {
      marginLeft: 20,
      fontSize: 12
    },
    '& h2': {
      fontSize: 20,
      fontWeight: 'bold'
    }
  },
  input: {
    maxWidth: 75,
    width: 75,
    minHeight: 30,
    padding: 10,
    textAlign: 'center',
    border: '2px solid #002380',
    borderRadius: '5px',
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0
    }
  },
  percentContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& span': {
      marginLeft: 2,
      color: '#002380',
      fontWeight: 600
    }
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    padding: 30,
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    '& p': {
      fontSize: 14,
      color: '#001E41'
    },
    '& svg': {
      color: '#001E41'
    }
  },
  expandOpen: {
    '& svg': {
      transform: 'rotate(180deg)'
    }
  },
  loader: {
    flex: 1,
    textAlign: 'right'
  },
  expandIconContainer: {
    display: 'flex',
    justifyContent: 'right',
    '& > button.MuiIconButton-root:hover': {
      backgroundColor: 'unset'
    }
  }
}));

// TODO: move to utils
function MergeObj(original, newobject) {
  for (const [key, value] of Object.entries(newobject)) {
    Object.keys(value).map((subkey) => (original[key][subkey] = value[subkey]));
  }
  return original;
}

const TableCash = ({ scenario }) => {
  const dispatch = useDispatch();
  const outputs = useSelector((state) => state.FinancialModelReducer.outputs);
  const inputs = useSelector((state) => state.FinancialModelReducer.inputs);
  const [state, setState] = useState({});
  const [inputsToSend, setInputsToSend] = useState({});
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    setState(inputs);
  }, [dispatch, inputs]);

  const handleChangeInput = ({ target: { name, value } }) => {
    if (value.length <= 0) {
      setState({ ...state, [name]: null });
      setInputsToSend({ [name]: null });
    } else {
      setState({ ...state, [name]: Number(value) });
      setInputsToSend({ [name]: Number(value) });
    }
  };

  const handleKeyPress = async (e) => {
    if (e.key === 'Enter') {
      try {
        setLoading(true);
        const {
          data: { data }
        } = await axios.put(
          `http://drivee.localhost/api/fmodel/scenarios/${scenario.id}`,
          { input_object: inputsToSend }
        );

        dispatch(setOutputs(MergeObj(outputs, data.outputs)));
        dispatch(setInputs({ ...inputs, ...inputsToSend }));
        setInputsToSend({});
        setLoading(false);
        return data;
      } catch (error) {
        setLoading(false);
        console.log('ERROOORRR', error);
      }
    }
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <TableContainer className={classes.tableContainer} component={Paper}>
      <div className={classes.header}>
        <h2>Cash flow statement</h2>
        <p>
          As of year end 31/12, all figures in EURm (except otherwise stated)
        </p>
        <div className={classes.loader}>
          {loading && <CircularProgress size={20} />}
        </div>
      </div>
      <Table
        aria-label="customized table"
        className={classes.table}
        size="small">
        <TableHead>
          <StrongTableRow>
            <StyledTableCellStrong />
            <StyledTableCellStrong align="center">2019</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2020E</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2021E</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2022E</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2023E</StyledTableCellStrong>
            <StyledTableCellStrong align="center">2024E</StyledTableCellStrong>
          </StrongTableRow>
        </TableHead>
        <TableBody>
          <StyledTableRow>
            <TableCellTitleStrong>PBT</TableCellTitleStrong>
            {Object.values(outputs.pbt)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </StyledTableRow>
          <TableRow>
            <TableCellTitle>
              Adjustements to reconcile PBT to operating cash flow{' '}
              <span>(pre NWC change)</span>
            </TableCellTitle>
            {Object.values(outputs.pbt_op_cash_adj)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>o/w Depre. & amort. charges (+)</TableCellTitle>
            {Object.values(outputs.o_w_depr_amort_charge)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>o/w Tax paid (-)</TableCellTitle>
            {Object.values(outputs.o_w_tax_paid)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>
              Operating cash flow <span>(pre NWC change)</span>
            </TableCellTitle>
            {Object.values(outputs.op_cash_flow)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>
              NWC change <span>(+ inflow / - outflow)</span>
            </TableCellTitle>
            {Object.values(outputs.nwc_change)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>NWC as % of revenues</TableCellTitle>

            <StyledTableCellStrong align="center">
              {outputs.nwc_p._0}
            </StyledTableCellStrong>

            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="nwc_p_1"
              placeholder={
                inputsToSend.nwc_p_1 === null ? null : outputs.nwc_p._1
              }
              value={state.nwc_p_1}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="nwc_p_2"
              placeholder={
                inputsToSend.nwc_p_2 === null ? null : outputs.nwc_p._2
              }
              value={state.nwc_p_2}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="nwc_p_3"
              placeholder={
                inputsToSend.nwc_p_3 === null ? null : outputs.nwc_p._3
              }
              value={state.nwc_p_3}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="nwc_p_4"
              placeholder={
                inputsToSend.nwc_p_4 === null ? null : outputs.nwc_p._4
              }
              value={state.nwc_p_4}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="nwc_p_5"
              placeholder={
                inputsToSend.nwc_p_5 === null ? null : outputs.nwc_p._5
              }
              value={state.nwc_p_5}
            />
          </TableRow>
          <StyledTableRow>
            <TableCellTitleStrong>
              Cash flow from operations(CFFO)
            </TableCellTitleStrong>
            {Object.values(outputs.op_cash_flow)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </StyledTableRow>
          <TableRow>
            <TableCellTitle>Total net capex (-)</TableCellTitle>
            {Object.values(outputs.total_net_capex)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>Capex as % of revenues</TableCellTitle>

            <StyledTableCellStrong align="center">
              {outputs.capex_p._2}
            </StyledTableCellStrong>

            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="capex_p_1"
              placeholder={
                inputsToSend.capex_p_1 === null ? null : outputs.capex_p._1
              }
              value={state.capex_p_1}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="capex_p_2"
              placeholder={
                inputsToSend.capex_p_2 === null ? null : outputs.capex_p._2
              }
              value={state.capex_p_2}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="capex_p_3"
              placeholder={
                inputsToSend.capex_p_3 === null ? null : outputs.capex_p._3
              }
              value={state.capex_p_3}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="capex_p_4"
              placeholder={
                inputsToSend.capex_p_4 === null ? null : outputs.capex_p._4
              }
              value={state.capex_p_4}
            />
            <InputControlled
              handleChange={handleChangeInput}
              keyPress={handleKeyPress}
              name="capex_p_5"
              placeholder={
                inputsToSend.capex_p_5 === null ? null : outputs.capex_p._5
              }
              value={state.capex_p_5}
            />
          </TableRow>
          <TableRow>
            <TableCellTitle>
              Investement in subsidiaries & associates (-)
            </TableCellTitle>
            {Object.values(outputs.invest_sub_asso)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
          <TableRow>
            <TableCellTitle>
              Other cash from investing <span>(+ inflow / - outflow)</span>
            </TableCellTitle>
            {Object.values(outputs.other_cffi)
              .slice(1)
              .map((val) => (
                <StyledTableCellStrong align="center">
                  {val}
                </StyledTableCellStrong>
              ))}
          </TableRow>
        </TableBody>
      </Table>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <Table className={classes.table} size="small">
          <TableBody>
            <StyledTableRow>
              <TableCellTitleStrong>
                Cash flow from investing (CFFF)
              </TableCellTitleStrong>
              {Object.values(outputs.cfff)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </StyledTableRow>
            <TableRow>
              <TableCellTitle>Capital increase (+)</TableCellTitle>
              {Object.values(outputs.cap_increase)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <TableRow>
              <TableCellTitle>
                Cap reduction / Share buy back (-)
              </TableCellTitle>
              {Object.values(outputs.cap_reduction)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <TableRow>
              <TableCellTitle>Dividends (-)</TableCellTitle>

              <StyledTableCellStrong align="center">
                {outputs.div_paid._0}
              </StyledTableCellStrong>

              <InputControlled
                handleChange={handleChangeInput}
                keyPress={handleKeyPress}
                name="div_paid_1"
                placeholder={
                  inputsToSend.div_paid_1 === null ? null : outputs.div_paid._1
                }
                value={state.div_paid_1}
              />
              <InputControlled
                handleChange={handleChangeInput}
                keyPress={handleKeyPress}
                name="div_paid_2"
                placeholder={
                  inputsToSend.div_paid_2 === null ? null : outputs.div_paid._2
                }
                value={state.div_paid_2}
              />
              <InputControlled
                handleChange={handleChangeInput}
                keyPress={handleKeyPress}
                name="div_paid_3"
                placeholder={
                  inputsToSend.div_paid_3 === null ? null : outputs.div_paid._3
                }
                value={state.div_paid_3}
              />
              <InputControlled
                handleChange={handleChangeInput}
                keyPress={handleKeyPress}
                name="div_paid_4"
                placeholder={
                  inputsToSend.div_paid_4 === null ? null : outputs.div_paid._4
                }
                value={state.div_paid_4}
              />
              <InputControlled
                handleChange={handleChangeInput}
                keyPress={handleKeyPress}
                name="div_paid_5"
                placeholder={
                  inputsToSend.div_paid_5 === null ? null : outputs.div_paid._5
                }
                value={state.div_paid_5}
              />
            </TableRow>
            <TableRow>
              <TableCellTitle>Change in debt</TableCellTitle>
              {Object.values(outputs.change_cash)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <TableRow>
              <TableCellTitle>
                Other cash from financing <span>(+ inflow / - outflow)</span>
              </TableCellTitle>
              {Object.values(outputs.other_cfff)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <StyledTableRow>
              <TableCellTitleStrong>
                Cash flow from financing (CFFF)
              </TableCellTitleStrong>
              {Object.values(outputs.cfff)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </StyledTableRow>
            <TableRow>
              <TableCellTitle>Other inflow/outflow</TableCellTitle>
              {Object.values(outputs.other_liab)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <NetTableRow>
              <TableCellTitleStrong>Net change in cash</TableCellTitleStrong>
              {Object.values(outputs.change_cash)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </NetTableRow>
            <TableRow>
              <TableCellTitle>
                Cash at the beginning of the period
              </TableCellTitle>
              {Object.values(outputs.cash_beginning)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </TableRow>
            <NetTableRow>
              <TableCellTitleStrong>
                Cash at the end of the period
              </TableCellTitleStrong>
              {Object.values(outputs.cash_end)
                .slice(1)
                .map((val) => (
                  <StyledTableCellStrong align="center">
                    {val}
                  </StyledTableCellStrong>
                ))}
            </NetTableRow>
          </TableBody>
        </Table>
      </Collapse>
      <div className={classes.expandIconContainer}>
        <IconButton
          aria-expanded={expanded}
          aria-label="show more"
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded
          })}
          disableRipple
          onClick={handleExpandClick}>
          <p>{expanded ? 'hide details' : 'expand for more details'}</p>
          <ExpandMoreIcon />
        </IconButton>
      </div>
    </TableContainer>
  );
};

export default TableCash;
